import authToken from "@/utils/authToken";
import api from "@/api/axios";
import { mapActions, mapGetters } from "vuex";

let isCheckingNetwork = false;

export default {
	computed: {
		...mapGetters({
			connection: "WSConnection",
			auth: "auth"
		}),
	},
	methods: {
		...mapActions([ 'WSConnect', 'WSConnectionOpen', 'WSConnectionClose', 'WSSubscribe' ]),
		
		connectionReady() {
			return this.connection && authToken && this.connection.readyState === 1;
		},
		
		// Функция, которая возвращает Promise и ждет, пока сокет РЕАЛЬНО откроется
		waitForOpen() {
			return new Promise((resolve) => {
				if (this.connectionReady()) {
					return resolve(true);
				}
				
				// Если сокет вообще не создан или закрыт
				if (!this.connection || this.connection.readyState === 3) {
					return resolve(false);
				}
				
				// Если сокет в статусе CONNECTING (0), подписываемся на его открытие
				const socket = this.connection;
				
				const handleOpen = () => {
					cleanup();
					resolve(true);
				};
				const handleClose = () => {
					cleanup();
					resolve(false);
				};
				const cleanup = () => {
					socket.removeEventListener('open', handleOpen);
					socket.removeEventListener('close', handleClose);
				};
				
				socket.addEventListener('open', handleOpen);
				socket.addEventListener('close', handleClose);
				
				// Предохранитель: если сокет завис, прекращаем ждать через 4 секунды
				setTimeout(() => {
					cleanup();
					resolve(this.connectionReady());
				}, 4000);
			});
		},
		
		// Возвращает Promise, который выполнится, когда сокет станет доступен
		async checkConnection() {
			// 1. Если сокет уже готов — сразу выходим
			if (this.connectionReady()) return true;
			
			// Если сокет находится в процессе подключения (статус 0), просто ждем его
			if (this.connection && this.connection.readyState === 0) {
				return await this.waitForOpen();
			}
			
			// 2. Если сокета нет или он закрыт, пробуем восстановить
			if (!this.connection || this.connection.readyState === WebSocket.CLOSED) {
				if (isCheckingNetwork) return await this.waitForOpen();
				
				isCheckingNetwork = true;
				try {
					const res = await api.get("/manage/websocket/check?get=1");
					
					if (res.data && res.data.success && this.auth && this.auth.status === true) {
						// 1. Создаем сокет
						this.WSConnect();
						
						// 2. Навешиваем события и передаем параметры авторизации
						this.WSConnectionOpen({
							groups: this.auth.groups,
							idUser: this.auth.user?.idUser,
							idBranch: this.auth.currentBranch,
						});
						
						return await this.waitForOpen();
					}
				} catch (err) {
					console.error("Ошибка проверки доступности WebSocket:", err);
				} finally {
					isCheckingNetwork = false;
				}
			}
			
			return this.connectionReady();
		},
		
		async addWSSubscription(data) {
			// Если сокет закрыт, checkConnection дождется HTTP-ответа и запустит сокет.
			const isReady = await this.checkConnection(data);
			
			// 2. Если сокет успешно открыт (или уже был открыт) — сохраняем подписку и отправляем её
			if (isReady) {
				this.WSSubscribe(data);
				
				if (this.connection && this.connection.readyState === 1) {
					this.connection.send(JSON.stringify({ action: 'addSubscription', data }));
				}
			}
		}
	}
};